import type {BranchAndTagCountData} from '@github-ui/code-view-shared/contexts/BranchAndTagContext'
import type {RecentlyTouchedBranches} from '@github-ui/code-view-shared/contexts/RecentlyTouchedBranchesContext'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import {isUIService} from '@github-ui/runtime-environment'

export interface OverviewData {
  branchAndTagCount: BranchAndTagCountData
  recentlyTouchedBranches: RecentlyTouchedBranches
}

export function isOverviewDataEnabled() {
  return isUIService && isFeatureEnabled('ui_service_code_view_overview_data')
}

export const overviewDataQuery = {
  queryName: 'overviewData' as const,
  queryDeps: ({params}: {params: Record<string, string | undefined>}) => ({
    pathname: `/${params.owner}/${params.repo}/overview-data`,
  }),
  // eslint-disable-next-line @github-ui/github-monorepo/require-query-schema -- This rollout combines two established Rails JSON payloads that do not have generated schemas.
  queryFn: async (queryKey: {queryDeps: {pathname: string}}) => queryFnFetch<OverviewData>(queryKey),
  type: QueryRouteQueryType.Deferred,
  enabled: isOverviewDataEnabled,
}
